@use "~theme/typography";
@use "~theme/breakpoints";

.introduction {
  background-color: var(--blue-03-at-30);
  border-bottom: 1px solid var(--blue-01-at-30);
  padding: 16px 24px;

  @include breakpoints.desktop {
    padding: 24px 32px;
  }
}

.header {
  @include typography.heading2;
  color: var(--blue-01);
  margin: 0 0 4px;
}
